import React, { useEffect, useState } from "react";
import "./Extensions.css";
import Header from "../../Header/Header";
import axios from "axios";
import { useHistory } from "react-router-dom";

const Extensions = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [msg, setMsg] = useState("");
  const [editingCredits, setEditingCredits] = useState({});
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    const tkn = window.sessionStorage.getItem("Token");
    const usr = window.sessionStorage.getItem("User");
    if (!tkn || !usr) {
      history.push("/");
    }
  }, []);

  useEffect(() => {
    const url = process.env.REACT_APP_BASEURL;
    setLoading(true);
    axios
      .get(`${url}/api/credit-extention/get-credit-extention-data`, {
        headers: { "x-access-token": window.sessionStorage.getItem("Token") },
      })
      .then((res) => {
        if (res.data?.result && Array.isArray(res.data.result)) {
          setData(res.data.result);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const handleInputChange = (id, value) => {
    setEditingCredits((prev) => ({
      ...prev,
      [id]: value.replace(/[^0-9]/g, ""),
    }));
  };

  const commitCreditChange = async (id) => {
    const newValue = editingCredits[id];
    const rowIndex = data.findIndex((row) => row.id === id);
    if (
      rowIndex !== -1 &&
      newValue !== undefined &&
      newValue !== "" &&
      newValue !== data[rowIndex].credits.toString()
    ) {
      try {
        const url = process.env.REACT_APP_BASEURL;
        await axios.put(
          `${url}/api/credit-extention/update-credit`,
          { id, credit: newValue },
          {
            headers: {
              "x-access-token": window.sessionStorage.getItem("Token"),
            },
          }
        );
        setMsg("Credit updated successfully");
        const newData = [...data];
        newData[rowIndex].credits = newValue;
        setData(newData);
      } catch (err) {
        setMsg("Failed to update credits");
      }
      setTimeout(() => setMsg(""), 1000);
    }
    setEditingCredits((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
  };

  const handleKeyDown = (e, id) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
  };

  const handleBlur = (id) => {
    commitCreditChange(id);
  };

  return (
    <>
      <Header />
      <div className="mx-4" style={{ marginTop: "72px" }}>
        <h5 className="py-4 text-center">Extensions</h5>
        {msg && (
          <div className="alert alert-success py-1 w-50 mx-auto text-center">
            {msg}
          </div>
        )}
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="table-responsive d-flex justify-content-center">
            <table
              className="table table-bordered table-hover extension-table"
              style={{ maxWidth: 1100 }}
            >
              <thead>
                <tr className="table-secondary text-center">
                  <th>Extension</th>
                  <th>Action</th>
                  <th>Variable</th>
                  <th>Credits</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <tr key={row.id}>
                    <td>{row.extension}</td>
                    <td>{row.action}</td>
                    <td>{row.variable}</td>
                    <td style={{ maxWidth: 80 }} className="text-center">
                      <input
                        type="text"
                        className="form-control form-control-sm text-center"
                        value={
                          editingCredits[row.id] !== undefined
                            ? editingCredits[row.id]
                            : row.credits
                        }
                        onChange={(e) => handleInputChange(row.id, e.target.value)}
                        onBlur={() => handleBlur(row.id)}
                        onKeyDown={(e) => handleKeyDown(e, row.id)}
                        style={{ width: 60, display: "inline-block" }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default Extensions;
